function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Uses the singleton pattern to represents the state of the selected products.
 * It also has some helper methods related with the format of products.
 * @private
 */
var ShoppingCart = /*#__PURE__*/function () {
  function ShoppingCart() {
    _classCallCheck(this, ShoppingCart);
    if (!ShoppingCart.instance) {
      this.productList = {};
      ShoppingCart.instance = this;
    }
    return ShoppingCart.instance;
  }

  /**
   * Adds a product to the shopping cart.
   *
   * @param {Product} product Product object
   */
  return _createClass(ShoppingCart, [{
    key: "addProduct",
    value: function addProduct(product) {
      this.productList[product.id] = [product.getSelectedAmount(product.id), product.name];
    }

    /**
     * Returns a list of products from the cart, where on each position of the list is the product id.
     *
     * @returns {{}} Returns an object containing the cart products
     */
  }, {
    key: "getProductList",
    value: function getProductList() {
      return this.productList;
    }

    /**
     * Returns a formatted array of products with the following format:
     * [{'ProductId': X, 'Quantity': Y}, ....]
     *
     * @returns {Array} Array of formatted products
     */
  }, {
    key: "getFormattedProducts",
    value: function getFormattedProducts() {
      var _this = this;
      // Format it as the backend expects it
      var formattedProductList = [];
      Object.keys(this.productList).forEach(function (productId) {
        formattedProductList.push({
          ProductId: productId,
          Quantity: _this.productList[productId][0],
          Title: _this.productList[productId][1].replace(/["„“]+/g, "'").replace(/[`~!@#$%^&*()_|+\-=?;:<>]+/g, "").replaceAll("<br>", "")
        });
      });
      return formattedProductList;
    }

    /**
     * Returns registered amount of a product from the shoppingCart
     *
     * @param {int} productId Id of the product to get how many amount there is in the shoppingCart
     * @returns {boolean|int} Returns the amount of a registered product by ID, or false if the product is not in the shoppingCart
     */
  }, {
    key: "getProductAmount",
    value: function getProductAmount(productId) {
      return this.productList[productId] ? this.productList[productId] : false;
    }

    /**
     * Removes a product from the shoppingCart and update in DOM
     *
     * @param {int} productId Id of the product to remove
     * @returns {{}} Returns the list of products without the removed product.
     */
  }, {
    key: "removeProduct",
    value: function removeProduct(productId) {
      var elements = document.querySelectorAll(".product[data-product-id=\"".concat(productId, "\"]"));
      elements.forEach(function (element) {
        element.querySelector('.product__amount input').value = 0;
      });
      delete this.productList[productId];
      return this.productList;
    }

    /**
     * Empties the cart.
     */
  }, {
    key: "clearCart",
    value: function clearCart() {
      this.productList = {};
    }
  }]);
}();
export default ShoppingCart;